/**
 *
 * @type {{name: string, id: string}}
 */
export const STAFF_ADD_ORDER_SUCCESS = {id: 'STAFF_ADD_ORDER_SUCCESS', 'name': '急救转诊添加成功'}

/**
 *
 * @type {{name: string, id: string}}
 */
export const STAFF_ADD_CAR_SUCCESS = {id: 'STAFF_ADD_CAR_SUCCESS', 'name': '急救车添加成功'}

/**
 *
 * @type {{name: string, id: string}}
 */
export const STAFF_ADD_DRIVER_SUCCESS = {id: 'STAFF_ADD_DRIVER_SUCCESS', 'name': '司机添加成功'}

/**
 * 安排转诊成功
 * @type {{name: string, id: string}}
 */
export const STAFF_PROCESS_ORDER_SUCCESS = {id: 'STAFF_PROCESS_ORDER_SUCCESS', name: '安排转诊成功'};

/**
 *
 * @type {{name: string, id: string}}
 */
export const STAFF_ADD_IN_OUT_FORM_SUCCESS = {id: 'STAFF_ADD_IN_OUT_FORM_SUCCESS', name: '转入转出申请成功'};

export const STAFF_ADD_PG = {id: 'STAFF_ADD_PG', name: '患者评估新建成功'}

export const STAFF_EDIT_PG = {id: 'STAFF_EDIT_PG', name: '患者评估修改成功'}